import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"position":"absolute","height":"48px","width":"48px","min-width":"48px","top":"102px","left":"130px","z-index":"4","display":"block"},
  class: "ion-hide-lg-down"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"border-bottom":"2px solid rgba(0, 0, 0, 0.13)","width":"160px","height":"2px"} }, null, -1)
const _hoisted_3 = { class: "pb-1 flex w100" }
const _hoisted_4 = { class: "subtitle-1 pt-1 ion-text-center" }
const _hoisted_5 = { class: "pb-1 flex w100" }
const _hoisted_6 = {
  class: "subtitle-1 pt-1 ion-text-center",
  style: {"transform":"scale(0.9)"}
}
const _hoisted_7 = { class: "pb-1 flex w100" }
const _hoisted_8 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_9 = { class: "pb-1 flex w100" }
const _hoisted_10 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_11 = { class: "pb-1 flex w100" }
const _hoisted_12 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_13 = { class: "pb-1 flex w100" }
const _hoisted_14 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_15 = { class: "pb-1 flex w100" }
const _hoisted_16 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_17 = { class: "pb-1 flex w100" }
const _hoisted_18 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_19 = { class: "pb-1 flex w100" }
const _hoisted_20 = { class: "body-1 pt-1 ion-text-center" }
const _hoisted_21 = { class: "pb-1 flex w100" }
const _hoisted_22 = { class: "body-1 pt-1 ion-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_yrp_circle_logo = _resolveComponent("yrp-circle-logo")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_circle_progress = _resolveComponent("circle-progress")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ion_fab_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCompleteCheckIn()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, {
            size: "large",
            button: "",
            icon: _ctx.checkmarkCircleOutline
          }, null, 8, ["icon"])
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.getUser && _ctx.userDetails && _ctx.userDetails.wizardCompleted && _ctx.isHome]
    ]),
    _withDirectives(_createVNode(_component_ion_menu, {
      side: "start",
      "menu-id": "first",
      "content-id": "main",
      swipeGesture: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_header, { style: {"border-right":"4px solid rgb(190, 190, 190) !important"} }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, { class: "px-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_yrp_circle_logo, {
                  class: "my-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/home/dashboard')))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_2,
        _createVNode(_component_ion_content, {
          id: "other",
          class: "ion-padding-none"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_list, {
              class: "px-0 pt-0 pb-4 flex-column",
              style: {"background":"transparent","height":"100%","min-height":"900px","border-right":"4px solid rgb(190, 190, 190) !important"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/home/bio'))),
                  button: "",
                  class: "my-pointer",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-center flex" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_circle_progress, {
                            class: "auto",
                            "border-width": 6,
                            "border-bg-width": 6,
                            "empty-color": "#c6d6dc",
                            "fill-color": "#99ca3c",
                            size: 32,
                            percent: _ctx.latestCheckIn ? _ctx.latestCheckIn.biological : 0
                          }, null, 8, ["percent"])
                        ]),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("menu.bio")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/home/psych'))),
                  button: "",
                  class: "my-pointer",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_circle_progress, {
                            class: "auto",
                            "border-width": 6,
                            "border-bg-width": 6,
                            "empty-color": "#c6d6dc",
                            "fill-color": "#58c4eb",
                            size: 32,
                            percent: _ctx.latestCheckIn ? _ctx.latestCheckIn.psychological : 0
                          }, null, 8, ["percent"])
                        ]),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("menu.psych")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/home/social'))),
                  button: "",
                  class: "my-pointer",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_circle_progress, {
                            class: "auto",
                            "border-width": 6,
                            "border-bg-width": 6,
                            "empty-color": "#c6d6dc",
                            "fill-color": "#f47b4b",
                            size: 32,
                            percent: _ctx.latestCheckIn ? _ctx.latestCheckIn.social : 0
                          }, null, 8, ["percent"])
                        ]),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("menu.social")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/home/spirit'))),
                  button: "",
                  class: "my-pointer flex-column",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_circle_progress, {
                            class: "auto",
                            "border-width": 6,
                            "border-bg-width": 6,
                            "empty-color": "#c6d6dc",
                            "fill-color": "#9a57a3",
                            size: 32,
                            percent: _ctx.latestCheckIn ? _ctx.latestCheckIn.spiritual : 0
                          }, null, 8, ["percent"])
                        ]),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("menu.spirit")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item_divider),
                _createVNode(_component_ion_item, {
                  button: "",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/home/contacts'))),
                  class: "my-pointer",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ion_icon, {
                            class: "auto",
                            size: "large",
                            icon: _ctx.peopleOutline
                          }, null, 8, ["icon"])
                        ]),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("menu.resources")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  button: "",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/home/search'))),
                  class: "my-pointer",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_ion_icon, {
                            class: "auto",
                            size: "large",
                            icon: _ctx.searchOutline
                          }, null, 8, ["icon"])
                        ]),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("menu.search")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  button: "",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/home/events'))),
                  class: "my-pointer",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_ion_icon, {
                            class: "auto",
                            size: "large",
                            icon: _ctx.calendarOutline
                          }, null, 8, ["icon"])
                        ]),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("menu.events")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  button: "",
                  onClick: _ctx.openInDistress,
                  class: "my-pointer",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_ion_icon, {
                            class: "auto",
                            size: "large",
                            icon: _ctx.helpBuoyOutline
                          }, null, 8, ["icon"])
                        ]),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("menu.help")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_ion_item_divider),
                _createVNode(_component_ion_item, {
                  button: "",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/home/settings'))),
                  class: "my-pointer",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_ion_icon, {
                            class: "auto",
                            size: "large",
                            icon: _ctx.settingsOutline
                          }, null, 8, ["icon"])
                        ]),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("menu.settings")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.logout())),
                  button: "",
                  class: "my-pointer",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_ion_icon, {
                            class: "auto",
                            size: "large",
                            icon: _ctx.logOutOutline
                          }, null, 8, ["icon"])
                        ]),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("menu.logout")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.getUser && _ctx.userDetails && _ctx.userDetails.wizardCompleted]
    ])
  ], 64))
}